import Vue from 'vue';
//import Moment from 'moment';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    getAiaConfig: function () {
        //var timestamp = Moment().unix();
        var url = `${this.config().bzbsBlobUrl}/webconfig/aia/aia_config.json`;
        return BzbsApi.connectBzbsGetBlob(url);
    },
}
